import { DialogTitle } from '@headlessui/react';
import { DatePicker, Modal } from '@retainerclub/common';
import PropTypes from 'prop-types';
import OrderPlanStartModalWrapper from './OrderPlanStartModalWrapper';

function OrderPlanStartModal({ open, handleCloseModal, order }) {
  return (
    <Modal
      open={open}
      setOpen={handleCloseModal}
      size="2xl"
      zdex={9999}
      panelClass="relative overflow-hidden min-h-[600px] px-4 pt-5 pb-4 sm:my-8 sm:p-6 text-left rounded-lg bg-white shadow-xl data-closed:translate-y-4 data-enter:translate-y-0 data-leave:translate-y-4 data-closed:scale-95 data-enter:scale-100 data-leave:scale-95 transition duration-300 ease-out data-closed:opacity-0 data-enter:opacity-100 data-leave:opacity-0 sm:w-full sm:max-w-2xl sm:data-closed:translate-y-0 sm:data-leave:translate-y-0"
    >
      <div>
        <div className="text-center">
          <DialogTitle
            as="h2"
            className="font-semibold text-2xl text-rcgray-900 capitalize leading-6"
          >
            Set Plan Start Delay
          </DialogTitle>
        </div>
        <div className="mt-6">
          <OrderPlanStartModalWrapper
            handleCloseModal={handleCloseModal}
            order={order}
          >
            <div className="mt-8 sm:col-span-6">
              <DatePicker
                name="planStartDelay"
                label="Plan Start Delay Date"
                isFutureDate
                includeTodayInFuture
                title="Select a date when this plan order should be processed"
              />
              <p className="mt-6 text-rcgray-500 text-sm">
                Select a date when this plan order should be processed. Setting
                today's date will process the order immediately. Future dates
                will delay processing until that date. If a date is already set,
                you can clear it using the "Clear Date" button.
              </p>
            </div>
          </OrderPlanStartModalWrapper>
        </div>
      </div>
    </Modal>
  );
}

OrderPlanStartModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  order: PropTypes.shape({
    id: PropTypes.string.isRequired,
    planStartDelay: PropTypes.string,
  }).isRequired,
};

export default OrderPlanStartModal;
